<bca-start-upload
    class="dialog-body"
    [isUploading]="isUploading$ | async"
    [selectedImage]="faceImage$ | async"
    [metrics]="faceImageMetrics$ | async"
    (cancel)="onCancel()"
    (fileSelected)="onFileSelected($event)"
    (save)="onSave()"
    (chooseAnother)="onChoose()">
</bca-start-upload>
